/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// this id needs to be changed in "index.html" for initialization
// under head tag -> google analytics script tag -> src
export const gaID = 'G-7QD3GFT9H7';